/* Butikker og kundeservice: status ("Åben til 18.00") udregnet i browseren i dansk tid.
   Data kommer fra metaobjekterne "butik", "kundeservice" og "Særlige åbningstider" via snippets/butik-data.liquid.
   Ugetabellen rendres i Liquid (snippets/butik-tider.liquid). Shopify cacher siden, så her tegnes den kun om,
   hvis siden er fra en anden dag end i dag (data-sig afviger). Samme regler som i butik-tider. Uden JS vises tiderne uden status.
   I-blokken (14/10-2026): den normale uge står urørt, særlige åbningstider i dag og 13 dage frem står i en blok under.
   Flersproget (20/10-2026): alle tekster, dage, måneder og tidsformat kommer fra temaets sprogfiler (nøglerne butikker.*)
   via "i18n" i butik-data. Mangler de, bruges de danske nedenfor. */
(function () {
  if (window.PitayaButik) return;
  var TZ = 'Europe/Copenhagen';
  var SP_DAYS = 14;
  var T = {
    dage: 'Mandag,Tirsdag,Onsdag,Torsdag,Fredag,Lørdag,Søndag',
    dage_inde: 'mandag,tirsdag,onsdag,torsdag,fredag,lørdag,søndag',
    maaneder: 'januar,februar,marts,april,maj,juni,juli,august,september,oktober,november,december',
    maaneder_kort: 'jan.,feb.,mar.,apr.,maj,jun.,jul.,aug.,sep.,okt.,nov.,dec.',
    dato: '{d}. {m}', dato_lang: '{dag} {d}. {m}', dag_dato: '{dag} {d}. {m}', dag_d: '{dag} {d}.', interval: '{a} - {b}', tid_sep: '.',
    lukket: 'Lukket', i_morgen: 'i morgen', aabner_dato: 'Åbner {dato}', aaben_til: 'Åben til {t}', aaben_lukker: 'Åben nu · lukker {t}',
    lukker: 'Lukker {t}', lukker_snart: 'Lukker snart · {t}', aabner: 'Åbner {t}', lukket_aabner: 'Lukket · åbner kl. {t}',
    aabner_dag: 'Åbner {dag} {t}', lukket_aabner_dag: 'Lukket · åbner {dag} {t}', saerlige: 'Særlige åbningstider'
  };
  var DA = {}; for (var dk in T) DA[dk] = T[dk];
  var DAYS, DAYS_IN, MONTHS, MON_S;
  function lists() { DAYS = T.dage.split(','); DAYS_IN = T.dage_inde.split(','); MONTHS = T.maaneder.split(','); MON_S = T.maaneder_kort.split(','); }
  /* Sprogets tekster fra butik-data (én gang). Kun ord og mønstre, der faktisk er udfyldt, erstatter de danske.
     Er en af listerne over dage eller måneder ikke 7 og 12 lange, bruges hele det danske sæt, så ord og mønstre ikke blandes */
  /* Teksterne kommer HTML-escaped fra Shopifys t-filter ("&amp;"). De afkodes her og escapes igen, hvor de sættes ind som HTML */
  function dec(s) { if (s.indexOf('&') < 0 || typeof document.createElement !== 'function') return s; var t = document.createElement('textarea'); t.innerHTML = s; return t.value; }
  function setLang(i) {
    if (i) for (var k in T) if (typeof i[k] === 'string' && i[k] && i[k].indexOf('translation missing') < 0) T[k] = dec(i[k]);
    lists();
    if (DAYS.length !== 7 || DAYS_IN.length !== 7 || MONTHS.length !== 12 || MON_S.length !== 12) { for (var d in DA) T[d] = DA[d]; lists(); }
  }
  setLang(null);
  var langSet = false;
  function f(s, o) { return String(s).replace(/\{(\w+)\}/g, function (m, k) { return o[k] != null ? o[k] : m; }); }

  function readData() {
    var el = document.getElementById('butik-data');
    if (!el) return null;
    var d; try { d = JSON.parse(el.textContent); } catch (e) { return null; }
    if (!langSet) { langSet = true; setLang(d.i18n); }
    return d;
  }
  function qs(name) { try { return new URLSearchParams(location.search).get(name); } catch (e) { return null; } }

  /* Nu i dansk tid. Til test: ?butik_tid=2026-11-22T12:00 i adressen */
  function now() {
    var q = ''; try { q = decodeURIComponent(location.search); } catch (e) {}
    var m = /[?&]butik_tid=(\d{4}-\d{2}-\d{2})T(\d{2}):(\d{2})/.exec(q);
    if (m) return mk(m[1], (+m[2]) * 60 + (+m[3]));
    var p = {};
    new Intl.DateTimeFormat('en-CA', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })
      .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    return mk(p.year + '-' + p.month + '-' + p.day, (+p.hour) * 60 + (+p.minute));
  }
  function mk(date, min) { return { date: date, dow: dowOf(date), min: min }; }
  function dowOf(ds) { return (new Date(ds + 'T12:00:00Z').getUTCDay() + 6) % 7; }
  function addDays(ds, n) { var d = new Date(ds + 'T12:00:00Z'); d.setUTCDate(d.getUTCDate() + n); return d.toISOString().slice(0, 10); }
  function fmt(m) { return String(Math.floor(m / 60)).padStart(2, '0') + T.tid_sep + String(m % 60).padStart(2, '0'); }
  function toMin(t) { var x = /^(\d{1,2}):(\d{2})$/.exec(t || ''); return x ? (+x[1]) * 60 + (+x[2]) : null; }
  function parseRange(s) {
    var x = /^(\d{1,2}:\d{2})-(\d{1,2}:\d{2})$/.exec((s || '').trim());
    if (!x) return null;
    var a = toMin(x[1]), b = toMin(x[2]);
    return (a != null && b != null && b > a) ? [a, b] : null;
  }
  function dateShort(ds) { var d = new Date(ds + 'T12:00:00Z'); return f(T.dato, { d: d.getUTCDate(), m: MON_S[d.getUTCMonth()] }); }
  function dateLong(ds) { var d = new Date(ds + 'T12:00:00Z'); return f(T.dato_lang, { dag: DAYS_IN[dowOf(ds)], d: d.getUTCDate(), m: MONTHS[d.getUTCMonth()] }); }
  function norm(v) { return String(v == null ? '' : v).trim().toLowerCase() || 'lukket'; }

  /* Særlige åbningstider: "fra|til|tider;..." -> [{f,t,v}] */
  function specials(o) {
    return String(o.sp || '').split(';').map(function (x) { var p = x.split('|'); return p.length === 3 ? { f: p[0], t: p[1], v: p[2] } : null; }).filter(Boolean);
  }
  function specialOn(o, ds) { return specials(o).filter(function (x) { return ds >= x.f && ds <= x.t; })[0] || null; }
  /* Faste tider for en dato: kommende tider ("Gælder fra") fra deres dato, ellers de nuværende */
  function regularOn(o, ds) {
    var w = dowOf(ds);
    if (o.next && o.next.from && ds >= o.next.from) return norm((o.next.days || [])[w]);
    return norm((o.days || [])[w]);
  }
  function valueOn(o, ds) { var sp = (o.opens && ds < o.opens) ? null : specialOn(o, ds); return sp ? norm(sp.v) : regularOn(o, ds); }
  function hasHours(o) { return (o.days || []).some(function (d) { return !!parseRange(d); }); }

  /* Tider på en given dato: særlig dag vinder over de faste tider */
  function hoursOn(o, ds) { var v = valueOn(o, ds); return { r: v === 'lukket' ? null : parseRange(v) }; }

  /* Kort i listen, lang i panelet */
  function status(o, n) {
    if (o.opens && n.date < o.opens) return { s: 'upcoming', label: f(T.aabner_dato, { dato: dateLong(o.opens) }), short: f(T.aabner_dato, { dato: dateShort(o.opens) }) };
    if (!hasHours(o) && !specials(o).length) return null;
    var t = hoursOn(o, n.date);
    if (t.r && n.min >= t.r[0] && n.min < t.r[1]) {
      var left = t.r[1] - n.min;
      var tt = { t: fmt(t.r[1]) };
      return left <= 60
        ? { s: 'soon', label: f(T.lukker_snart, tt), short: f(T.lukker, tt) }
        : { s: 'open', label: f(T.aaben_lukker, tt), short: f(T.aaben_til, tt) };
    }
    if (t.r && n.min < t.r[0]) return { s: 'closed', label: f(T.lukket_aabner, { t: fmt(t.r[0]) }), short: f(T.aabner, { t: fmt(t.r[0]) }) };
    for (var i = 1; i <= 7; i++) {
      var ds = addDays(n.date, i), h = hoursOn(o, ds);
      if (h.r) {
        var w = { dag: i === 1 ? T.i_morgen : DAYS_IN[dowOf(ds)], t: fmt(h.r[0]) };
        return { s: 'closed', label: f(T.lukket_aabner_dag, w), short: f(T.aabner_dag, w) };
      }
    }
    return { s: 'closed', label: T.lukket, short: T.lukket };
  }

  /* Ugetabellen og blokken, samme regler som snippets/butik-tider.liquid */
  function label(d1, d2) {
    var a = new Date(d1 + 'T12:00:00Z'), b = new Date(d2 + 'T12:00:00Z');
    var first = { dag: DAYS[dowOf(d1)], d: a.getUTCDate(), m: MON_S[a.getUTCMonth()] };
    if (d1 === d2) return f(T.dag_dato, first);
    var last = f(T.dag_dato, { dag: DAYS_IN[dowOf(d2)], d: b.getUTCDate(), m: MON_S[b.getUTCMonth()] });
    return f(T.interval, { a: f(a.getUTCMonth() === b.getUTCMonth() ? T.dag_d : T.dag_dato, first), b: last });
  }
  /* Er "Gælder fra" nået siden siden blev cachet, er de kommende tider nu de faste (som i Liquid på dagen) */
  function current(o, today) {
    if (!(o.next && o.next.from && today >= o.next.from)) return o;
    var c = {}; for (var k in o) c[k] = o[k];
    c.days = o.next.days; c.next = null; return c;
  }
  function val(v) { return v === 'lukket' ? T.lukket : v.replace(/:/g, T.tid_sep); }
  function rowsFor(o, today) {
    o = current(o, today);
    if ((o.days || []).join('|').indexOf(':') < 0) return null;
    var S = [], k, j;
    for (var n = 0; n < SP_DAYS; n++) {
      var ds = addDays(today, n), x = (o.opens && ds < o.opens) ? null : specialOn(o, ds);
      S.push({ d: ds, v: x ? norm(x.v) : '' });
    }
    var dow = dowOf(today), rows = [], sp = [];
    for (k = 0; k < 7; k = j + 1) {
      var vk = norm(o.days[k]); j = k;
      while (j < 6 && norm(o.days[j + 1]) === vk) j++;
      var days = [];
      for (var z = k; z <= j; z++) { var off = (z - dow + 7) % 7; if (!S[off].v) days.push(S[off].d); }
      rows.push({ lab: j === k ? DAYS[k] : f(T.interval, { a: DAYS[k], b: DAYS_IN[j] }), val: val(vk), raw: vk, days: days });
    }
    for (k = 0; k < SP_DAYS; k = j + 1) {
      j = k; if (!S[k].v) continue;
      while (j < SP_DAYS - 1 && S[j + 1].v === S[k].v) j++;
      var dd = []; for (var y = k; y <= j; y++) dd.push(S[y].d);
      sp.push({ lab: label(S[k].d, S[j].d), val: val(S[k].v), raw: S[k].v, days: dd });
    }
    return { rows: rows, sp: sp };
  }
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function sigOf(t, today) {
    function part(a) { return a.map(function (r) { return r.lab + '=' + r.val + ';'; }).join(''); }
    return today + '#' + part(t.rows) + '#' + part(t.sp);
  }

  function paintTable(tb, o, n) {
    var t = rowsFor(o, n.date);
    var isDiv = tb.getAttribute('data-row-tag') === 'div';
    var tc = tb.getAttribute('data-today-class') || 'is-today';
    if (t && tb.getAttribute('data-sig') !== null && tb.getAttribute('data-sig') !== sigOf(t, n.date)) {
      var row = function (r, extra) {
        var d = esc(r.days.join(','));
        return isDiv
          ? '<div class="npc-tr' + (extra || '') + (r.raw === 'lukket' ? ' dim' : '') + '" data-days="' + d + '"><span class="d">' + esc(r.lab) + '</span><span class="v">' + esc(r.val) + '</span></div>'
          : '<tr data-days="' + d + '"><td>' + esc(r.lab) + '</td><td>' + esc(r.val) + '</td></tr>';
      };
      if (isDiv) {
        tb.innerHTML = t.rows.map(function (r) { return row(r); }).join('') +
          (t.sp.length ? '<p class="npc-sp-h">' + esc(T.saerlige) + '</p>' + t.sp.map(function (r) { return row(r, ' npc-sp'); }).join('') : '');
      } else {
        tb.innerHTML = '<table class="bx-hours"><tbody>' + t.rows.map(function (r) { return row(r); }).join('') + '</tbody></table>' +
          (t.sp.length ? '<div class="bx-sp"><p class="bx-sp__h">' + esc(T.saerlige) + '</p><table class="bx-hours"><tbody>' + t.sp.map(function (r) { return row(r); }).join('') + '</tbody></table></div>' : '');
      }
      tb.setAttribute('data-sig', sigOf(t, n.date));
    }
    var upcoming = o.opens && n.date < o.opens;
    tb.querySelectorAll('[data-days]').forEach(function (tr) {
      tr.classList.toggle(tc, !upcoming && tr.getAttribute('data-days').split(',').indexOf(n.date) > -1);
    });
  }

  function paint(root) {
    var data = readData(); if (!data) return;
    var n = now();
    var byId = {};
    (data.stores || []).forEach(function (o) { byId[o.id] = o; });
    if (data.ks) byId.__ks = data.ks;
    root.querySelectorAll('[data-bx-status]').forEach(function (el) {
      var o = byId[el.getAttribute('data-bx-status')]; if (!o) return;
      var st = status(o, n);
      if (!st) { el.hidden = true; el.removeAttribute('data-pending'); return; }
      var txt = el.getAttribute('data-variant') === 'long' ? st.label : st.short;
      ['open', 'soon', 'closed', 'upcoming'].forEach(function (k) { el.classList.remove('bx-st--' + k); });
      el.classList.add('bx-st', 'bx-st--' + st.s);
      el.innerHTML = '<i aria-hidden="true"></i>' + esc(txt);
      el.hidden = false; el.removeAttribute('data-pending');
    });
    root.querySelectorAll('[data-bx-hours]').forEach(function (tb) {
      var o = byId[tb.getAttribute('data-bx-hours')]; if (o) paintTable(tb, o, n);
    });
  }

  window.PitayaButik = { status: status, now: now, paint: paint, rows: rowsFor, sig: sigOf };
  function run() { paint(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  setInterval(run, 60000);
  document.addEventListener('shopify:section:load', run);
})();
